export type KindT = 'success'|'error'|'info';

export type Toast = {
  title?: string,
  children?: any,
  kind?: KindT,
  time?: number,
  id?: number,
  testId?: string
}

export type MonitoringToastsState = {
  toastList: Toast[]
}

export const toastDefaultTime = 8000